import styled from 'styled-components';
import { BreakPoint } from '@makemydeal/dr-activities-common';
import { Typography } from '@interstate/components/Typography';

// Styled components for the mileage cost options slideout
export const FieldsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
    align-items: start;

    @media (max-width: ${BreakPoint.SMALL}) {
        grid-template-columns: repeat(1, 1fr);
    }
`;

// 2-column grid for Residual Breakdown tab
export const ResidualFieldsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
    align-items: start;

    @media (max-width: ${BreakPoint.SMALL}) {
        grid-template-columns: repeat(1, 1fr);
    }
`;

export const MileageSlideOutContainer = styled.div`
    flex: 1 1 auto;
    column-gap: 4%;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    min-height: 6.25rem;
`;

export const NumericInputContainer = styled.div`
    flex: 1 1 0;
    min-width: 0;
    position: relative;
`;

export const SectionTitle = styled(Typography)`
    margin-bottom: 1rem;
`;

// Header container for slideout
export const SlideOutHeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

// Subtitle for header
export const SlideOutSubtitle = styled(Typography)`
    color: rgba(0, 0, 0, 0.6);
    margin-top: 0.25rem;
`;
